import { render, staticRenderFns } from "./PrinterTester.yaml?vue&type=template&id=912345d6&component"
import script from "./PrinterTester.yaml?vue&type=script&lang=ts&component"
export * from "./PrinterTester.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports